import { Modal, ModalId } from "../../../../../features/ui"
import { FiscalDocument, fiscalDocumentHelpers } from "../../../../fiscal-documents"
import { useActions } from "./actions"

type Props = {
    fiscalDocument?: FiscalDocument
    onRefresh?: () => Promise<void>
}

export const AnnulInvoiceModal = (props: Props) => {
    const { fiscalDocument, onRefresh } = props

    const { describeFiscalDocument } = fiscalDocumentHelpers

    const { annulInvoice } = useActions(onRefresh)

    const onSubmit = () => fiscalDocument && annulInvoice(fiscalDocument)

    return (
        <Modal
            modalId={ModalId.ANNUL_INVOICE}
            title="Anular Factura"
            submitLabel="Anular"
            submitKind="secondary"
            widthSize="m"
            disableSubmit={!fiscalDocument}
            onSubmit={onSubmit}
        >
            <p>
                {fiscalDocument && `Está por anular ${describeFiscalDocument(fiscalDocument)}. `}
                Se generará una Nota de Crédito por el total y la operación volverá a quedar
                pendiente de facturación para emitir una factura con los datos corregidos.
            </p>
        </Modal>
    )
}
